import VacanciesPage from "./vacancies-page";

export default VacanciesPage;